<template>
    <div>
        <!-- class="hidden-sm hidden-xs" -->
            <div v-if="loggedIn" class="hidden-sm hidden-xs">
              <div class="profile-card">
                <img src="http://placehold.it/300x300" alt="user" class="profile-photo" />
                <h5><a href="timeline" class="text-white">{{user.user_name}}</a></h5>
                <a href="#" class="text-white"><i class="fa fa-shopping-cart"></i> 62 shops</a><br>
                <a href="#" class="text-white"><i class="ion ion-android-person-add"></i> 1,500 friends</a>
                
              </div><!--profile card ends-->
              <ul class="nav-news-feed">
                <li><i class="icon ion-ios-paper"></i><div><a href="#">Tradefair Newsfeed</a></div></li>
                <li><i class="icon fa fa-shopping-cart"></i><div><a href="#">Shops Following</a></div></li>
                <li><i class="icon ion-ios-people-outline"></i><div><a href="#">Friends</a></div></li>
                <li><i class="icon ion-chatboxes"></i><div><a href="#">Discussions / Messages</a></div></li>
                <li><i class="icon ion-images"></i><div><a href="#">Orders</a></div></li>
                <li><i class="icon fa fa-bell"></i><div><a href="#">No6ifications</a></div></li>
              </ul><!--news-feed links ends-->
            </div>
            
            <div class="hidden-xs">
              <div class="profile-card">
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                   Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> -->
              <p>Do you dream of the day you will use naijabrandtradefair2019 and really make so much sales? Like the day you will stop struggling to pay bills because sales aren’t forth coming, Or maybe you want to be your own brand influencer but your visibility keeps diminishing day by day …</p>
              </div>
              <!--activity feeds-->
              <div id="sticky-feeds">
                  <h4 class="grey">Ongoing Activities</h4>
                  <div class="feed-item">
                    <div class="live-activity">
                      <p><img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" /><a href="#" class="profile-link">Olu Jane Stores</a> Commented on a product</p>
                      <p class="text-muted">5 mins ago</p>
                    </div>
                  </div>
                  <div class="feed-item">
                    <div class="live-activity">
                      <p><img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" /><a href="#" class="profile-link">Lami Fashion Store</a> Has posted a product</p>
                      <p class="text-muted">an hour ago</p>
                    </div>
                  </div>
                  <div class="feed-item">
                    <div class="live-activity">
                      <p><img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" /><a href="#" class="profile-link">Trish Hairs</a> Liked friend's product</p>
                      <p class="text-muted">4 hours ago</p>
                    </div>
                  </div>
                  <div class="feed-item">
                    <div class="live-activity">
                      <p><img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" /><a href="#" class="profile-link">LuluBeads Crafts</a> has shared a product</p>
                      <p class="text-muted">a day ago</p>
                    </div>
                  </div>

                  <!--fairtalks-->
                  <!-- <div id="chat-block"> -->
                  <div>
                    <div class="title">Tradefair Talks</div>
                    <ul class="online-users list-inline">
                      <li><a href="#" title="Cynthia Belonwu"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                      <li><a href="#" title="Jubril Sani"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                      <li><a href="#" title="Sandra Oseni"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                      <li><a href="#" title="Titilo Bass"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                      <li><a href="#" title="Jayden Ajibade"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                      <li><a href="#" title="Nonso Obi"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                      <li><a href="#" title="Efiong Dun"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                      <li><a href="#" title="Chika Nnabi"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                      <li><a href="#" title="Bolaji Adewale"><img src="http://placehold.it/300x300" alt="user" class="img-responsive profile-photo" /><span class="online-dot"></span></a></li>
                    </ul>
                  </div><!--chat block ends-->
              </div>
             </div>
            
  </div>
</template>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'LeftSidebar',
    data () {
      return {
        user: {}, 
        loggedIn:false
      }
  },

methods: {
    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user.user_name = localStorage.getItem("sp_user");
        }
    },
  },
  created: function() {
    this.checkLoggedIn();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/templates/leftsidebar.vue